import React, { useState } from 'react'
import styled from 'styled-components'
import ExpandedPosition from './ExpandedPosition.jsx'
import { ArrowBigIcon } from '../../Icons/ArrowBigIcon'

const StyledTr = styled.tr`
  &:hover {
    background-color: rgba(0, 0, 0, 0.075);
  }
  border-top: ${(props) => (props.borderTop ? '1px solid #e0e0e0' : '')};
`
const PositionInstances = ({ article, position }) => {
    const [open, setOpen] = useState(true)
    return (
        <>
            <StyledTr
                borderTop
                onClick={(e) => setOpen((prev) => !prev)}
                aria-controls='example-collapse-text'
                role='button'
                aria-expanded={open}
                style={{ cursor: 'pointer' }}
                data-id={`position-${article.id}_${position.id}`}
            >
                <td>
                    <ArrowBigIcon variant={open ? 'down' : 'right'} />
                    {article.article.displayName}
                </td>
                <td>{article.article.articleNumber}</td>
                <td>
                    {position.articleVariant !== null &&
                        position.articleVariant.displayName}
                </td>
                <td>{position.quantity}</td>
            </StyledTr>
            {open ? (
                <>
                    <ExpandedPosition
                        position={position}
                        article={article}
                    />
                </>
            ) : null}
        </>
    )
}

export default PositionInstances
